module.exports = __webpack_public_path__ + "static/media/menu-boton.cf67d7dd.svg";